<script setup lang="ts">
import { useGetAllCanvasses } from "@/canvasses/canvassesCrud";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import EditLink from "@/components/links/EditLink.vue";
import { formatDatetime } from "@/utils/toFormattedDatetime";
import { Calendar, Map } from "@iconoir/vue";
import type { House } from "./types";

const props = defineProps<{
  house: House;
}>();

const { canvasses, getCanvassesStatus } = useGetAllCanvasses(props.house.id);
</script>
<template>
  <HandleQueryStatus :query-status="getCanvassesStatus">
    <div class="container container-lg">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th><Map /> Gebiet</th>
            <th><Calendar /> Erstelldatum</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="canvass in canvasses" :key="canvass.id">
            <td>{{ canvass.name }}</td>
            <td>{{ canvass.area.name }}</td>
            <td>
              {{ formatDatetime(canvass.createdAt, { dateStyle: "medium" }) }}
            </td>
            <td class="actions">
              <EditLink
                :to="{ name: 'editCanvass', params: { id: canvass.id } }"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </HandleQueryStatus>
</template>
